import { firm } from "./site";

export type PublishedCaseResult = {
  id: string;
  figure: string;
  outcome: string;
  title: string;
  summary: string;
  detail: string;
  sourceUrl: string;
  storyPath?: string;
  storyLabel?: string;
  sourceNote?: string;
  location?: string;
};

// First-party published results; amounts are not net proceeds or collection claims.
export const featuredCaseResult: PublishedCaseResult = {
  id: "kent-county-verdict",
  figure: "$27.5 million",
  outcome: "Motorcycle injury jury verdict",
  title: "Historic $27.5 million jury verdict",
  summary:
    `A car driver checking her blood-glucose level on a phone app crossed the centerline and struck a motorcyclist, causing injuries that included a leg amputation. ${firm.displayName} led the trial team in Kent County.`,
  detail: "The firm’s case report identifies this as Michigan’s largest motorcycle injury verdict, based on its research.",
  sourceUrl: "https://www.motorcyclelawyermichigan.com/27-million-motorcycle-injury-verdict/",
  storyPath: "/27-million-motorcycle-injury-verdict/",
  storyLabel: "Read the verdict story",
};

export const additionalCaseResults: PublishedCaseResult[] = [
  {
    id: "couple-settlement",
    figure: "$1,475,000",
    outcome: "Combined settlement",
    title: "A husband and wife. Two serious injuries.",
    summary:
      "Sean Murphy secured a combined pain-and-suffering settlement for a Northern Michigan couple injured when a distracted driver turned into their path.",
    detail:
      "Both required multiple surgeries. The firm reports that the pain-and-suffering portion settled at mediation after depositions. This is the combined amount for the couple.",
    sourceUrl: "https://www.motorcyclelawyermichigan.com/sean-murphy-1-48-million-motorcycle-crash-settlement/",
    storyPath: "/sean-murphy-1-48-million-motorcycle-crash-settlement/",
    storyLabel: "Read the settlement story",
  },
  {
    id: "construction-verdict",
    figure: "$2 million",
    outcome: "Verdict",
    title: "A fatal crash involving road construction",
    summary: "A wrongful-death verdict involving a car crash and a road construction company’s improper signage and negligence in St. Clair County, Michigan.",
    detail: "",
    sourceUrl: "https://www.motorcyclelawyermichigan.com/",
    sourceNote: "Published result summary from the firm’s results list.",
  },
  {
    id: "broken-leg-settlement",
    figure: "$1.5 million",
    outcome: "Settlement",
    title: "A broken leg after a motorcycle crash",
    summary: "A motorcyclist suffered a broken leg when a company employee turned left into the rider’s path.",
    detail: "",
    sourceUrl: "https://www.motorcyclelawyermichigan.com/",
    sourceNote: "Published result summary from the firm’s results list.",
  },
  {
    id: "macomb-liability-verdict",
    figure: "60%",
    outcome: "Fault assigned to the van driver",
    title: "Impossible Verdict",
    summary:
      "After a liability-only trial in Macomb County, the jury assigned 60% fault to the defendant van driver.",
    detail:
      "The motorcycle had rear-ended a van that braked for an emergency vehicle. The published story describes the fault verdict; it does not state a dollar amount.",
    sourceUrl: "https://www.motorcyclelawyermichigan.com/we-won-the-impossible-motorcycle-case/",
    storyPath: "/we-won-the-impossible-motorcycle-case/",
    storyLabel: "Read the full case story",
  },
];

export const homepageWins = additionalCaseResults.filter((result) => result.id !== "construction-verdict");

// October 26 client list, checked against published records where available.
// RV and courier summaries are limited to Jason's supplied facts.
const archiveUrl = "https://www.motorcyclelawyermichigan.com/biker-lawsuit-awards-settlements/";
export const requestedCaseResults: PublishedCaseResult[] = [
  featuredCaseResult,
  { id:"rv-wrongful-death-settlement", figure:"$2 million", outcome:"Settlement", title:"A motorcyclist struck by an RV", summary:"Wrongful-death settlement for a Michigan motorcyclist hit by an RV.", detail:"", location:"Michigan", sourceUrl:archiveUrl },
  { ...additionalCaseResults.find(result=>result.id==="construction-verdict")!, location:"St. Clair County, Michigan" },
  additionalCaseResults.find(result=>result.id==="broken-leg-settlement")!,
  { ...additionalCaseResults.find(result=>result.id==="couple-settlement")!, location:"Michigan’s Upper Peninsula" },
  { id:"elderly-driver-settlement", figure:"$1.4 million", outcome:"Settlement", title:"A motorcyclist hit by an elderly driver", summary:"A motorcycle crash caused a severe leg injury requiring multiple surgeries.", detail:"", sourceUrl:archiveUrl },
  { id:"lapeer-wrongful-death-settlement", figure:"$1.25 million", outcome:"Settlement", title:"A fatal crash with disputed liability", summary:"Wrongful-death settlement after a motorcycle crash involving no helmet and disputed liability.", detail:"", location:"Lapeer County, Michigan", sourceUrl:archiveUrl },
  { id:"delivery-truck-settlement", figure:"$1.2 million", outcome:"Settlement", title:"A motorcyclist struck by a delivery truck", summary:"A delivery truck operated by a major courier service struck a motorcyclist.", detail:"", sourceUrl:archiveUrl },
  { id:"wayne-bodily-injury-arbitration", figure:"$1.2 million", outcome:"Arbitration", title:"A bodily-injury case involving severe injuries", summary:"Severe injuries to internal organs, the abdomen and an arm.", detail:"", location:"Wayne County, Michigan", sourceUrl:archiveUrl },
  { id:"semi-truck-settlement", figure:"$1 million", outcome:"Settlement", title:"A motorcyclist struck by a semi-truck", summary:"A motorcycle crash involving multiple broken bones and wage loss.", detail:"", location:"Wayne County, Michigan", sourceUrl:archiveUrl },
];
